import { render, staticRenderFns } from "./PigRunEditor.vue?vue&type=template&id=343503f0"
import script from "./PigRunEditor.vue?vue&type=script&lang=ts"
export * from "./PigRunEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports